import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { noticeInteraction } from "../../../../../../services/monitoring";
import ReaderDialog, { ReaderDialogType } from "../../common/ReaderDialog";

interface LaunchAppDialogProps {
  open: boolean;
  downloadUrl?: string;
  onRequestClose: () => void;
}

const DialogContent: React.FC = () => {
  return (
    <div>
      <FormattedMessage id={"QRDownloadApps.launchAppDialog.pending"} />
    </div>
  );
};

const LaunchAppDialog: React.FC<LaunchAppDialogProps> = ({
  open,
  downloadUrl,
  onRequestClose,
}) => {
  const intl = useIntl();

  return (
    <ReaderDialog
      type={ReaderDialogType.Vstui}
      open={open}
      alert
      title={intl.formatMessage({ id: "QRDownloadApps.launchAppDialog.title" })}
      size="small"
      onRequestClose={onRequestClose}
      primaryActionButton={{
        label: intl.formatMessage({
          id: "QRDownloadApps.launchAppDialog.install",
        }),
        onClick: () => {
          noticeInteraction("download_app_launch_app");
          window.open(downloadUrl);
        },
      }}
    >
      <DialogContent />
    </ReaderDialog>
  );
};

export default LaunchAppDialog;
